// @flow
import React, { PureComponent } from 'react';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import ButtonLink from '@liveauctioneers/caterwaul-components/lib/ButtonLink/ButtonLink';
import Cookies from 'universal-cookie';
import { enableBrowserNotificationsUrl } from '../../utils/urls';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons/faExclamationTriangle';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import notificationPermissions from '../../enums/notificationPermissions';
import styles from './DismissableGetWebNotificationsBanner.module.scss';

const cookie = new Cookies();
const COOKIE_MAX_AGE = 86400 * 365; // 365 days
const COOKIE_NAME = 'dismissableNotificationBanner';
const COOKIE_BODY = 'dismissed';

type Props = {
    forceEnableBanner: boolean,
    forceEnableNotificationsBannerDismiss: Function,
    permission: string,
    placedHighBid: boolean,
    requestBrowserPermission: Function,
};

type State = {
    dismissed: boolean,
    forceDismissed: boolean,
};

export default class DismissableGetWebNotificationsBanner extends PureComponent<Props, State> {
    state = {
        dismissed: false,
        forceDismissed: false,
    };

    componentDidMount = () => {
        this.isBannerDismissed();
    };

    componentDidUpdate = (prevProps: Props) => {
        if (!prevProps.forceEnableBanner && Boolean(this.props.forceEnableBanner)) {
            this.setState({ forceDismissed: false });
        }
    };

    isBannerDismissed = () => {
        const hasBeenChecked = cookie.get(COOKIE_NAME);
        this.setState({ dismissed: COOKIE_BODY === hasBeenChecked });
        return COOKIE_BODY === hasBeenChecked;
    };

    setCookieChecked = () => {
        cookie.set(COOKIE_NAME, COOKIE_BODY, { maxAge: COOKIE_MAX_AGE });
        this.setState({ dismissed: true, forceDismissed: true });
        this.props.forceEnableNotificationsBannerDismiss();
    };

    onClickEnableNotifications = () => {
        this.props.requestBrowserPermission();
    };

    render() {
        const { forceEnableBanner, permission, placedHighBid } = this.props;

        if (!forceEnableBanner) {
            if (!placedHighBid || permission === notificationPermissions.GRANTED || Boolean(this.state.dismissed)) {
                return null;
            }
        } else {
            if (Boolean(this.state.forceDismissed)) {
                return null;
            }
        }

        const disallowedNotifications = permission === notificationPermissions.DENIED;

        return (
            <div id="webNotificationsBanner" className={styles.webNotificationContainer}>
                {disallowedNotifications ? (
                    <div id="webNotificationsDenied" className={styles.innerContainer}>
                        <FontAwesomeIcon className={styles.warningSignIcon} icon={faExclamationTriangle} />
                        <div className={styles.getNotificationText}>
                            <FormattedMessage id="notifications.modify_your_browser_preferences" />
                        </div>
                        <ButtonLink
                            className={styles.button}
                            external
                            rel="noopener"
                            target="_blank"
                            url={enableBrowserNotificationsUrl}
                        >
                            <FormattedMessage id="top_learn_more" />
                        </ButtonLink>
                    </div>
                ) : (
                    <div id="webNotificationsDefault" className={styles.innerContainer}>
                        <div className={styles.getNotificationText}>
                            <FormattedMessage id="notifications.get_notifications_when_outbid" />
                        </div>
                        <Button className={styles.button} onClick={this.onClickEnableNotifications}>
                            <FormattedMessage id="notifications.enable_browser_notifications" />
                        </Button>
                    </div>
                )}
                <FontAwesomeIcon className={styles.closeBox} icon={faTimes} onClick={this.setCookieChecked} />
            </div>
        );
    }
}
